import { render, staticRenderFns } from "./TvModeBanner.vue?vue&type=template&id=6ca07657&scoped=true"
import script from "./TvModeBanner.vue?vue&type=script&lang=js"
export * from "./TvModeBanner.vue?vue&type=script&lang=js"
import style0 from "./TvModeBanner.vue?vue&type=style&index=0&id=6ca07657&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca07657",
  null
  
)

export default component.exports